// 添加/编辑字段的浮动卡片组件
import React, {useEffect} from 'react';
import {Card, Form, Input, Select, Button} from 'antd';
import {
  FontColorsOutlined,
  MenuOutlined,
  FieldNumberOutlined,
  CalendarOutlined,
  DownCircleOutlined
} from '@ant-design/icons';
import {CardPosition} from '../types';

const {Option} = Select;

interface FieldEditorCardProps {
  visible: boolean;
  position: CardPosition;
  operateType: 'add' | 'edit';
  initialValues: {fieldName?: string; fieldType?: string};
  selectedFieldType: string;
  onConfirm: (values: any) => void;
  onCancel: () => void;
  onFieldTypeChange: (value: string) => void;
}

export const FieldEditorCard: React.FC<FieldEditorCardProps> = ({
  visible,
  position,
  operateType,
  initialValues,
  selectedFieldType,
  onConfirm,
  onCancel,
  onFieldTypeChange
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({
        fieldName: initialValues.fieldName || '',
        fieldType: initialValues.fieldType || 'text'
      });
    } else {
      form.resetFields();
    }
  }, [visible, form]);

  if (!visible) return null;

  return (
    <Card
      style={{
        position: 'absolute',
        top: position.top,
        left: position.left,
        zIndex: 1000,
        width: '300px',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)'
      }}
      bodyStyle={{padding: '20px 10px 0 10px'}}
    >
      <Form
        form={form}
        name="fieldForm"
        layout="vertical"
        onFinish={onConfirm}
        autoComplete="off"
      >
        <Form.Item
          label="名称"
          name="fieldName"
          rules={[{required: true, message: '必填'}]}
        >
          <Input placeholder="请输入字段名称" />
        </Form.Item>

        <Form.Item
          label="字段类型"
          name="fieldType"
          rules={[{required: true, message: '必填'}]}
        >
          <Select
            placeholder="请选择字段类型"
            onChange={onFieldTypeChange}
            disabled={operateType === 'edit'}
          >
            <Option value="text">
              <FontColorsOutlined /> 文本
            </Option>
            <Option value="textArea">
              <MenuOutlined /> 多行文本
            </Option>
            <Option value="number">
              <FieldNumberOutlined /> 数字
            </Option>
            <Option value="date">
              <CalendarOutlined /> 日期
            </Option>
            <Option value="list">
              <DownCircleOutlined /> 下拉框
            </Option>
          </Select>
        </Form.Item>

        {selectedFieldType === 'list' && operateType === 'add' && (
          <Form.Item
            label="下拉选项"
            name="fieldOptions"
            rules={[{required: true, message: '请至少输入一个选项'}]}
          >
            <Select
              mode="tags"
              style={{width: '100%'}}
              placeholder="输入选项后按回车确认"
              tokenSeparators={[',']}
            />
          </Form.Item>
        )}

        <Form.Item style={{textAlign: 'right'}}>
          <Button onClick={onCancel} style={{marginRight: '10px'}}>
            取消
          </Button>
          <Button type="primary" htmlType="submit">
            确认
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};
